import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PageRenderer from './pages/PageRenderer';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-warm-light text-warm-dark antialiased">
        {/* Navigation Header */}
        <Header />

        {/* Main Content Area */}
        <div className="flex-grow">
          <Routes>
            {/* Core Pages */}
            <Route path="/" element={<PageRenderer />} />
            <Route path="/om-solveig" element={<PageRenderer />} />
            <Route path="/terapi" element={<PageRenderer />} />
            <Route path="/terapi/familiebehandling" element={<PageRenderer />} />
            <Route path="/terapi/parterapi" element={<PageRenderer />} />
            <Route path="/terapi/traumer-og-seksuelle-overgreb-i-barndommen" element={<PageRenderer />} />
            <Route path="/terapi/akut-terapi" element={<PageRenderer />} />
            <Route path="/kontakt" element={<PageRenderer />} />

            {/* Error Pages */}
            <Route path="/403" element={<Forbidden />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

export default App;
